// eslint-disable-next-line deprecate/import
import Link from 'next/link';

import { useNavLayout } from '@shared/common/components/NavLayout/NavLayoutContext';
import { nextProjectUrl } from '@shared/constants/urls';
import { ConnectWalletGuard } from '@shared/helpers/web3/wallet';

import { useMinBetAmount } from '@store:web/components/pages/MagicPredictionsPage/api/useMinBetAmount/useMinBetAmount';
import { DialogButton, DialogButtonsWrapper } from '@ui/uikit/components/common/Dialog';

interface MakePredictionSubmitButtonProps {
  walletBalance: number;
  isDisabled: boolean;
}

export const MakePredictionSubmitButton = ({
  walletBalance,
  isDisabled,
}: MakePredictionSubmitButtonProps) => {
  const { onBanxaBuyToken } = useNavLayout();
  const { data: minBetAmount } = useMinBetAmount();
  const minAvailableBetValue = minBetAmount?.value ?? 0;

  return (
    <DialogButtonsWrapper>
      <ConnectWalletGuard>
        {walletBalance < minAvailableBetValue ? (
          <div className="flex flex-col gap-2 justify-center w-full max-w-full">
            <button className="msq-btn msq-btn-lg msq-btn-secondary" type="button">
              <Link target="_blank" href={nextProjectUrl.swap('/')}>
                Get USDT with Swap
              </Link>
            </button>
            <button
              onClick={onBanxaBuyToken}
              className="msq-btn msq-btn-lg msq-btn-secondary"
              type="button"
            >
              Get USDT with Card
            </button>
          </div>
        ) : (
          <DialogButton
            type="submit"
            isDisabled={isDisabled}
            variant={isDisabled ? 'secondary' : 'primary'}
          >
            {isDisabled ? 'Enter Amount' : 'Confirm'}
          </DialogButton>
        )}
      </ConnectWalletGuard>
    </DialogButtonsWrapper>
  );
};
